import { Component } from 'react'
import PropTypes from 'prop-types'

import { Modal, ModalBody } from 'components/modal'

import ShareByEmailForm from '../../containers/share-by-email-form'

class ShareByEmailModal extends Component {
  render() {
    const { onHide, show } = this.props

    return (
      <Modal
        onHide={onHide}
        show={show}
        title="Share your registry link by email"
      >
        <ModalBody>
          <ShareByEmailForm
            onHide={onHide}
            onSubmitSuccess={this.handleSubmitSuccess.bind(this)}
          />
        </ModalBody>
      </Modal>
    )
  }

  handleSubmitSuccess() {
    const { onHide } = this.props
    onHide()
    PubSub.publish(BLConstants.FLASH_MESSAGE, {
      variant: 'success',
      message: 'Your message has been sent successfully.',
    })
  }
}

ShareByEmailModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}

export default ShareByEmailModal
